const prefix = 'FILTERS/'

export const SET_FULLTEXT = prefix + 'SET_FULLTEXT'
export const SET_HDBL = prefix + 'SET_HDBL'
export const SET_ONLINE = prefix + 'SET_ONLINE'
export const SET_OFFLINE = prefix + 'SET_OFFLINE'
export const SET_DATE = prefix + 'SET_DATE'
export const RESET = prefix + 'RESET'



// WEBPACK FOOTER //
// ./src/types/filters.js